import {createContext, useContext} from 'react';
import type {Citation, InsightTopic} from '../../../store/features/calls/callsService';

export interface InsightsActions {
    jumpToCitation: (citation: Citation) => void;
    openTopic: (topic: InsightTopic) => void;
}

const noop = () => undefined;

export const InsightsActionsContext = createContext<InsightsActions>({jumpToCitation: noop, openTopic: noop});

export const useInsightsActions = (): InsightsActions => useContext(InsightsActionsContext);
